<template lang="pug">
.twitch__wrap
  h1.twitch__title(v-html="$t('twitch.title')")

  .twitch__auth
    p.twitch__auth-text {{ $t("twitch.notauth.text") }}
    .twitch__auth-buttons
      .button.button--corner.button--red(@click="signin('steam')")
        img(:src="getSteamIcon")
        span {{ $t("twitch.notauth.steam") }}
      .button.button--corner.button--red(@click="signin('mygames')")
        img(:src="getMarketIcon")
        span {{ $t("twitch.notauth.mygames") }}
    p.twitch__auth-text.twitch__auth-note {{ $t("twitch.notauth.note") }}
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("global");
import ls from "@godweb/frontend-base/src/libs/helpers/LocalStorageWrapper";

export default {
  name: "TwitchNotAuth",
  props: {
    lsKeys: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  computed: {
    ...mapGetters([
      "isUserNotAuthed",
      "isUserAuthedNotRegistered",
      "isUserInProject",
      "isSteamUser",
    ]),
    getSteamIcon() {
      return require("@/assets/images/steam-round.svg");
    },
    getMarketIcon() {
      return require("@/assets/images/mygames-market.svg");
    },
  },

  methods: {
    signin(method) {
      if (this.isUserInProject) {
        if (this.areMethodAndOriginSame(method)) {
          this.$emit("changeView", "connect");
          ls.setItem(this.lsKeys.form_to_show, null);
          ls.setItem(this.lsKeys.logged_in_with, null);
        } else {
          ls.setItem(this.lsKeys.form_to_show, method);
          this.$authService.logout();
        }
      } else {
        if (this.isUserAuthedNotRegistered) {
          this.$authService.showProjectReg();
        } else {
          method === "mygames"
            ? this.$authService.showSignin()
            : this.$authService.showSteamSignin();
        }
        ls.setItem(this.lsKeys.logged_in_with, method);
      }
    },
    areMethodAndOriginSame(method) {
      return (
        (this.isSteamUser && method === "steam") || (!this.isSteamUser && method === "mygames")
      );
    },
  },
};
</script>
